import { useEffect } from "react";
import { useHistory } from "react-router-dom";

import { clearSignupContext } from "../api";
import { ShellDataResponseBody } from "../types";

export const useBuyNowJourney = (
  businessUserId: string,
  signupContext: ShellDataResponseBody["signupContext"],
  verified: boolean,
) => {
  const history = useHistory();

  useEffect(() => {
    (async () => {
      if (businessUserId && signupContext && verified) {
        await clearSignupContext(businessUserId);
        const query = `businessModules=${signupContext.businessModule}&billingCycle=${signupContext.billingCycle}&buyNow=true`;
        history.push(`/subscription?${query}`);
      }
    })();
  }, [businessUserId, signupContext, verified]);
};
